<template>
    <div id="pwa-intervention-report" class="mx-2">
        <button-go-back text="Détails intervention"></button-go-back>

        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <div class="intervention-details__card">
                    <p class="font-medium mb-2 text-sm">Validation</p>
                    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
                    <div class="leading-none mb-2 text-sm">
                        <span class="font-medium">Intervention :</span>
                        <span class="ml-1 font-medium text-info">{{ intervention.category.name }}</span>
                    </div>
	                <div class="leading-none mb-1 text-sm">
		                <span class="font-medium">Dispositifs :</span>
		                <span class="ml-1 font-medium" :class="`text-${infosDevices.color}`">{{ infosDevices.text }}</span>
	                </div>
                </div>
            </div>
        </div>

        <div class="md-layout md-gutter mt-2" v-if="intervention.category_id === 1">
            <div class="md-layout-item md-size-100">
                <div class="intervention-details__card relative">
                    <p class="font-medium mb-2 text-sm">Demande</p>
                    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
                    <div class="px-2 pt-1">
                        <div class="md-multiselect md-multiselect-multiple">
                            <label>Types de demande</label>
                            <multiselect v-model="demand.types"
                                         :options="demandTypes"
                                         :disabled="!needDemand"
                                         :multiple="true"
                                         :searchable="false"
                                         :close-on-select="false"
                                         :allow-empty="false"
                                         :show-labels="false"
                                         label="name"
                                         track-by="id">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                        <md-field class="md-invalid mt-4 mb-1.5">
                            <label>Message</label>
                            <md-textarea v-model="demand.text" md-autogrow :disabled="!needDemand"></md-textarea>
                            <validation-error :errors="apiValidationErrors.text" />
                        </md-field>
                    </div>
                    <div class="overlay-demand" :class="{'active': !needDemand}"></div>
                </div>
            </div>
        </div>

        <div class="md-layout md-gutter mt-2">
            <div class="md-layout-item md-size-100">
                <div class="intervention-details__card">
                    <p class="font-medium mb-2 text-sm">Clôture</p>
                    <md-divider class="mb-2 -mt-1 -mx-2"></md-divider>
                    <div class="flex items-center justify-end mb-1">
                        <md-button class="md-success md-icon-button md-raised my-0" @click="validateDemand" :disabled="loading">
                            <font-awesome-icon class="md-icon" :icon="['fa', loading ? 'sync-alt' : 'check-circle']" :class="{'animate-spin': loading}" />
                            <span class="font-medium leading-none ml-2">Clôturer l'intervention</span>
                        </md-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="calendar-overlay opacity-100 fixed z-50 w-full h-full" v-if="updating">
            <div class="h-full w-full flex items-center justify-center">
                <md-progress-spinner class="md-white" md-mode="indeterminate"
                                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import indexedDBMixin from "@/mixins/indexed-db-mixin";

import ButtonGoBack from "../components/ButtonGoBack";
import { mapState } from "vuex";

export default {
    name: "PwaInterventionClosure",
    components: { ButtonGoBack, ValidationError },
    mixins: [formMixin, indexedDBMixin],
    data() {
        return {
            demandTypes: [],
	        needDevices: false,
            intervention: {
				category: {},
                devices: [],
                checkedDevices: {
                    sameInterventionType: 0,
                    notSameInterventionType: 0
                },
	            notCheckedDevices: {
		            sameInterventionType: 0,
		            notSameInterventionType: 0
	            },
            },
            needDemand: false,
            demand: {
                types: [],
                text: '',
                isValid: false
            },
            updating: true,
	        loading: false
        }
    },
    computed: mapState({
        user: state => state.pwaAuth.technician,
        infosDevices() {
            return this.needDevices ? { color: 'danger', text: 'Dispositifs manquants' }
	            : { color: 'success', text: 'Tous les dispositifs requis ont été saisis' }
        }
    }),
    methods: {
        async getInterventionDetails() {
	        const intervention = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}`)
	        const devices = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/devices`)
            this.intervention = intervention.value
            this.needDevices = devices.value.checked.sameInterventionType.length < (devices.value.checked.sameInterventionType.length + devices.value.notChecked.sameInterventionType.length)

            if(this.intervention.category_id === 1 && this.needDevices) {
                await this.getDemandTypes()
                this.needDemand = true
                this.demand.types.push(this.demandTypes[1])
                this.demand.text = `Tous les dispositifs ne sont pas saisis.\nRaison : `
            }
            this.updating = false
        },
        async getDemandTypes() {
	        const demandTypes = await this.fetchDataFromIndexedDB(`pwa/demand_types`)
            this.demandTypes = demandTypes.value
        },
        validateDemand() {
            this.resetApiValidation()
            let errors = []

            if(this.needDemand) {
                if(!this.demand.text) {
                    errors.push({
                        source: { pointer: '/data/attributes/text' },
                        detail: 'Le texte de la demande est obligatoire'
                    })
                }
            }

            if(errors.length > 0) {
                this.setApiValidation(errors)
            } else {
                this.submitClosure()
            }
        },
        async submitClosure() {
			this.loading = true
            const demand = this.needDemand ?
                { types: this.demand.types.map(type => type.id).sort(), message: this.demand.text } : null

	        const site = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.intervention.id}/site`)

	        const payload = {
		        access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
		        day: this.$moment(this.intervention.planningable.start_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
		        demand: demand,
		        client_id: site.value.client_id,
		        site_id: site.value.id,
		        user_id: this.user.id,
	        }

            try {
				const intervention = await  this.fetchDataFromIndexedDB(`pwa/intervention/${this.intervention.id}`)
	            intervention.value.status_id = 6

	            const planning = await this.fetchDataFromIndexedDB(`pwa/planning`)
	            planning.value.days.map(day => {
		            if(day.day === payload.day) {
			            day.plannings.map(planning => {
				            if(planning.intervention && planning.intervention.id === intervention.value.id) {
					            planning.intervention.status_id = 6
				            }
			            })
		            }
	            })

	            const db = await this.getIndexedDBConnection()
	            const tx = db.transaction('data', 'readwrite')
	            const store = tx.objectStore('data')
	            store.put({ key: `pwa/intervention/${intervention.value.id}`, value: intervention.value })
	            store.put({ key: `pwa/planning`, value: planning.value })

	            await this.storeRequest(`pwa/planning/${intervention.value.id}/closure`, payload)
                await this.$store.dispatch('alerts/success', 'Intervention clôtutée')
                this.$router.back()
            } catch (e) {
				this.loading = false
            }
        }
    },
    mounted() {
        this.getInterventionDetails()
    },
    watch: {
        'demand.type'(newVal) {
            if(!newVal) {
                this.demand.isValid = false
            }
        },
        'demand.text'(newVal) {
            if(!newVal) {
                this.demand.isValid = false
            }
        },
    }
}
</script>

<style scoped lang="scss">
.overlay-demand {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $gray-light;
    opacity: 0.5;
    border-radius: 3px;
    display: none;

    &.active {
        z-index: 15;
        display: block;
    }
}
</style>
